import { useEffect, useState } from 'react';
import { useNavigate } from "react-router-dom";
import {
  updateMetaTags,
  delete_stream,
  unfollow_stream,
  get_created_streams,
  get_created_streams_page,
  get_followed_streams,
  get_stream,
  create_stream,
} from '../script';
import StreamModal from '../Util/StreamModal';
import InstantModal from '../Util/InstantModal';
import Card from 'react-bootstrap/Card';
import Button from 'react-bootstrap/Button';
import ButtonGroup from 'react-bootstrap/ButtonGroup';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPlus, faHatWizard } from '@fortawesome/free-solid-svg-icons';

import OverlayTrigger from 'react-bootstrap/OverlayTrigger';
import Tooltip from 'react-bootstrap/Tooltip';

async function get_profile(email) {
  try {
    const response = await fetch(`https://sixhats-backend.onrender.com/user_profile/${email}`);
    if (response.ok) {
      const responseData = await response.json();
      console.log("Profile data:", responseData);
      return responseData;
    } 
  } catch (error) {
    console.error('Error getting profile:', error);
    return false;
  }
}

export default function Streams(props) {
  // TODO: See how JS enums or equivalent work
  const navigate = useNavigate();

  const [created_streams, set_created_streams] = useState([]);
  const [followed_streams, set_followed_streams] = useState([]);
  const [showCreateStreamModal, setShowCreateStreamModal] = useState(false);
  const [showInstantStreamModal, setShowInstantStreamModal] = useState(false);

  // "created" for user-created streams, "joined" for joined streams belonging to other users, "vaults" for bookmarked insight vaults
  const [streamlistShown, setStreamListShown] = useState("created");

  const [isProUser, setIsProUser] = useState(false);


  function handleStreamListShown(event) {
    setStreamListShown(event.target.value);
  }

  const renderTooltip = (props) => (
    <Tooltip id="button-tooltip">
      {props}
    </Tooltip>
  );

  useEffect(() => {
    updateMetaTags();
  
    if (props.loggedInEmail) {
      // Fetch user profile and determine if they are a Pro user
      get_profile(props.loggedInEmail).then((prof) => {
        if (prof) {
          setIsProUser(prof.user_type && prof.user_type.toLowerCase() === "pro");
        }
      });

       // Only fetch created streams for Pro users
        get_created_streams(props.loggedInEmail).then((result) => {
          set_created_streams(result);
        });
      
  
      get_followed_streams(props.loggedInEmail).then((result) => {
        set_followed_streams(result);
      });
    } else {
      alert("Not logged in");
      navigate("/", { replace: true });
    }
  
  }, []);
  

  return (
    <div className="content-div">
      <StreamModal showModal={showCreateStreamModal} setShowModal={setShowCreateStreamModal} />
      <InstantModal showModal={showInstantStreamModal} setShowModal={setShowInstantStreamModal} />
      <div className="stream-view">
        <h3 id="title-field" style={{ marginInline: "50px" }}>{props.loggedInEmail.split("@")[0]}'s Channels</h3>
        <div class="btn-group" role="group" aria-label="Basic radio toggle button group" style={{width:"100%"}}>
          <input type="radio" class="btn-check radio-checkbox" name="btnradio" id="btnradio1" value="created" autocomplete="off" checked={streamlistShown === "created"} onChange={handleStreamListShown} />
          <label class="btn btn-outline-primary radio-toggle" for="btnradio1">My Created Streams</label>

          <input type="radio" class="btn-check radio-checkbox" name="btnradio" id="btnradio2" value="joined" autocomplete="off" checked={streamlistShown === "joined"} onChange={handleStreamListShown} />
          <label class="btn btn-outline-primary radio-toggle" for="btnradio2">My Followed Streams</label>

          <input type="radio" class="btn-check radio-checkbox" name="btnradio" id="btnradio3" value="vaults" autocomplete="off" checked={streamlistShown === "vaults"} onChange={handleStreamListShown} />
          <label class="btn btn-outline-primary radio-toggle" for="btnradio3">My Insights Vault</label>
        </div>
        <hr style={{ height: "4px", width: "100%" }} />
        <div id="table_items" className="stream-table">
        {streamlistShown === "created" ? (
          isProUser ? (
            created_streams.length > 0 ? (
              created_streams.map((stream, i) => (
                <Card key={stream.guid}>
                  <div className={'stream-table-row ' + (i % 2 !== 0 ? 'dark-background' : '')}>
                    <div className='stream-table-left' onClick={() => {
                      if (window.confirm("Are you sure you want to delete this stream for all users? This action cannot be undone")) {
                        delete_stream(stream.guid, props.loggedInEmail).then(deleted => {
                          if (deleted) {
                            set_created_streams(created_streams.filter(s => s.guid !== stream.guid));
                          }
                        });
                      }
                    }}>
                      <i className="fa-solid fa-x fa-lg"></i>
                    </div>
                    <div className='stream-table-center' onClick={() => navigate("/s/" + stream.guid, { replace: true })}>
                      <h6>{stream.title}</h6>
                      <div style={{ display: "flex" }}>
                        <p style={{ marginRight: ".25rem" }}>created by: </p>
                        <OverlayTrigger placement="right" delay={{ show: 250, hide: 400 }} overlay={renderTooltip(stream.by)}>
                          <p>{stream.by.split("@")[0]}</p>
                        </OverlayTrigger>
                      </div>
                    </div>
                  </div>
                </Card>
              ))
            ) : (
              <p>No created streams available.</p>
            )
          ) : (
            <button className="btn" style={{ backgroundColor: "#BA7E2B", color: "#fff" }} onClick={() => navigate('/account')}>
              Upgrade to 6Hats Pro to create streams
            </button>
          )
        ) : (
          followed_streams.map((stream, i) => (
            (stream.by == "Automatic" && streamlistShown === "vaults") ||  (stream.by != "Automatic" && streamlistShown === "joined") ?
            <Card key={stream.guid}>
              <div className={'stream-table-row ' + (i % 2 !== 0 ? 'dark-background' : '')}>
                <div className='stream-table-left' onClick={() => {
                  unfollow_stream(stream.guid, props.loggedInEmail).then(unfollowed => {
                    if (unfollowed) {
                      set_followed_streams(followed_streams.filter(s => s.guid !== stream.guid));
                    }
                  });
                }}>
                  <i className="fa-solid fa-user-slash fa-lg"></i>
                </div>
                <div className='stream-table-center' onClick={() => navigate("/s/" + stream.guid, { replace: true })}>
                  <h6>{stream.title}</h6>
                  <div style={{ display: "flex" }}>
                    <p style={{ marginRight: ".25rem" }}>created by: </p>
                    <OverlayTrigger placement="right" delay={{ show: 250, hide: 400 }} overlay={renderTooltip(stream.by)}>
                      <p>{stream.by.split("@")[0]}</p>
                    </OverlayTrigger>
                  </div>
                </div>
              </div>
            </Card>  : null
          ))
        )}
      </div>
        {created_streams.length == 0 && followed_streams.length == 0 ?
          <p id="no_items"> Loading... </p> : null
        }
      </div>

      {/* Create new stream button fixed on the right side --> */}
      <OverlayTrigger
        placement="left"
        delay={{ show: 250, hide: 400 }}
        overlay={renderTooltip("Explore any topic instantly")}
      >
        <button 
          className="fixed-button upper-button" 
          id="btn-instant-stream" 
          onClick={() => setShowInstantStreamModal(true)}
        >
          <FontAwesomeIcon icon={faHatWizard} />
        </button>
      </OverlayTrigger>

      {isProUser && (
        <button 
          className="fixed-button lower-button" 
          id="btn-new-stream" 
          onClick={() => setShowCreateStreamModal(true)}
        >
          <FontAwesomeIcon icon={faPlus} />
        </button>
      )}
      <span>... {/* TODO Show during loading */}</span>


      {/* TODO Show during loading */}
      <span id="loading" className="center-screen" style={{ display: "none" }}>Loading...</span>

      {/* Spinner overlay */}
      <div id="spinner-overlay" className="spinner-overlay" style={{ display: "none" }}>
        <i className="fas fa-spinner fa-spin fa-3x" style={{ color: "gray" }}></i>
      </div>
    </div>
  );
}